import React from 'react';
import { Container, NavDropdown, Nav, Navbar, Form, FormControl, Button, Row, Offcanvas } from 'react-bootstrap'
import $ from "jquery"
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../js/main.js"
const Header = () => {

  const removeNotification = () => {
    $(".headernotification").fadeOut();
  }

  const expandSearch = () => {
    // 'use strict';
    console.log("ff")
    $(this).next().animate({
      width: '250px'
    });

  }

  return (
    <header>
      <Row>
        <div className='col-md-12 headernotification'>
          <p>Welcome to Rich-Oak Group.


            <span onClick={removeNotification} id="closeheadernotification"> X </span></p>
        </div>
      </Row>

      <Navbar bg="light" expand="lg">
        <Container fluid>
          <Navbar.Brand href="/"><img className="headerlogo" src="images/logo.png" /></Navbar.Brand>


          {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="">
    </Nav>
    <Nav>
    <Nav.Link   as={Link} to="/about"  eventKey="1" activeClassName="is-active" className="linkmenu" > About</Nav.Link>
        <Nav.Link  as={Link} to="/faq"   eventKey="2"  activeClassName="is-active" className="linkmenu" >FAQs</Nav.Link>

        <Nav.Link  as={Link} to="/login" eventKey="3"   ><Button   className="navmenu loginmenu">Login</Button></Nav.Link>
        <Nav.Link  as={Link} to="/signup" eventKey="3"   ><Button   className="createmenu" >Create an account</Button></Nav.Link>
    </Nav>
  </Navbar.Collapse> */}








          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav
              className="me-auto my-2 my-lg-0"
              // style={{ maxHeight: '100px' }}
              navbarScroll
            >
              <Nav.Link href="#action1" as={Link} to="/" eventKey="1" activeClassName="is-active" className="navmenu hmfirstmenu" >Home</Nav.Link>

              <NavDropdown className="hmothermenu" title="About Us" id="navbarScrollingDropdown">
                <div id="navbarScrollingDropdown2">
                  <NavDropdown.Item href="/firm">The Firm</NavDropdown.Item>
                  <NavDropdown.Item href="/boardofdirectors">Our Board of Directors</NavDropdown.Item>
                  <NavDropdown.Item href="/ourpeople" >Our People</NavDropdown.Item>
                  <NavDropdown.Divider className="mobilenavdivider" />
                </div>


                {/* <NavDropdown.Divider />
          <NavDropdown.Item href="#action5">
            Something else here
          </NavDropdown.Item> */}
              </NavDropdown>

              <NavDropdown className="hmothermenu" title="Our Business" id="navbarScrollingDropdown">
                <div id="navbarScrollingDropdown2">
                  <NavDropdown.Item href="/credit">Credit</NavDropdown.Item>
                  <NavDropdown.Item href="/investment">Investment</NavDropdown.Item>
                  <NavDropdown.Item href="/realestate">Real Estate</NavDropdown.Item>
                  <NavDropdown.Divider className="mobilenavdivider" />

                </div>
              </NavDropdown>

              <NavDropdown className="hmothermenu" title="Our Products" id="navbarScrollingDropdown">
                <div id="navbarScrollingDropdown2">
                  <NavDropdown.Item target="_blank" href="https://circlefinance.vercel.app/">Circle Finance</NavDropdown.Item>
                  {/* <NavDropdown.Item target="_blank" href="https://credi-sol.com">Credi-sol</NavDropdown.Item> */}
                  <NavDropdown.Item target="_blank" href="https://circlefinancewebapp-qvhc.vercel.app/">Earth VII</NavDropdown.Item>

                  <NavDropdown.Divider className="mobilenavdivider" />

                </div>
              </NavDropdown>

              {/* <Nav.Link className="hmothermenu2"  href="/media">Media</Nav.Link> */}

              <Nav.Link className="hmothermenu2" href="/career">Career</Nav.Link>

              {/* <Nav.Link className="hmothermenu2"  href="">Blog</Nav.Link> */}

            </Nav>


            {/* <Form className="d-flex headerseachform">
      <span class="fa fa-search headerseachformicon" aria-hidden="true"></span>
      <input type="text" name="search" class="extand"/>
      </Form> */}
          </Navbar.Collapse>


        </Container>
      </Navbar>

    </header>
  )

};


export default Header;